import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    display: 'w-10 flex center b-x b-grey-40 body-3 fw-medium duration'
  }
} satisfies VfConfig['stepper']
